import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { FC, useCallback } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';

import Modal from '../Modal';
import Autocomplete from '../forms/Autocomplete';
import ButtonLoadingIcon from '../forms/ButtonLoadingIcon';
import FormGrid from '../forms/FormGrid';
import FormStack from '../forms/FormStack';
import AssemblyStatusesEnum from '../../enums/assemblies/assembly-statuses.enum';
import OptionInterface from '../../interfaces/option.interface';
import AssembliesFiltersFieldValuesInterface from '../../interfaces/assemblies/assemblies-filters-field-values.interface';
import {
  onInvalidSubmit,
  validateArrayRequired,
} from '../../utils/validations';

const { CANCELED, CONFIRMED, INCOMPLETE, PROCESSING } = AssemblyStatusesEnum;

const ASSEMBLY_STATUSES_OPTIONS: OptionInterface[] = [
  {
    label: 'Confirmé',
    value: CONFIRMED,
  },
  {
    label: 'En traitement',
    value: PROCESSING,
  },
  { label: 'Incomplet', value: INCOMPLETE },
  { label: 'Annulé', value: CANCELED },
];

interface Props {
  opened: boolean;
  assemblyStatuses: AssemblyStatusesEnum[];
  onClose: () => void;
  onAssemblyStatusesChange: (assemblyStatuses: AssemblyStatusesEnum[]) => void;
}

const AssembliesDataTableFiltersModal: FC<Props> = ({
  onClose,
  onAssemblyStatusesChange,
  opened,
  assemblyStatuses,
}) => {
  const {
    control,
    formState: { isSubmitting },
    handleSubmit,
  } = useForm<AssembliesFiltersFieldValuesInterface>({
    defaultValues: {
      assemblyStatuses,
    },
  });

  const onSubmit: SubmitHandler<AssembliesFiltersFieldValuesInterface> =
    useCallback(
      (fieldValues) => {
        onAssemblyStatusesChange(fieldValues.assemblyStatuses);
        onClose();
      },
      [onClose, onAssemblyStatusesChange],
    );

  return (
    <Modal open={opened} onClose={onClose}>
      <form onSubmit={handleSubmit(onSubmit, onInvalidSubmit)}>
        <FormStack>
          <FormGrid>
            <Grid item xs={12}>
              <Typography variant="overline" component="h2">
                Filtres avancés
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Autocomplete
                control={control}
                label="Statuts"
                name="assemblyStatuses"
                options={ASSEMBLY_STATUSES_OPTIONS}
                rules={validateArrayRequired()}
                fullWidth
              />
            </Grid>
          </FormGrid>
        </FormStack>

        <Button
          disabled={isSubmitting}
          type="submit"
          variant="contained"
          sx={{ float: 'right' }}
          startIcon={isSubmitting && <ButtonLoadingIcon />}
        >
          Filtrer
        </Button>
      </form>
    </Modal>
  );
};

export default AssembliesDataTableFiltersModal;
